var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.996278 21.9559C0.962453 40.0366 4.83095 43.9196 22.9141 43.9559C40.9973 43.9922 44.8803 40.1248 44.9141 22.0441C44.948 3.96345 41.0795 0.0804458 22.9963 0.0441161C4.9131 0.0077865 1.0301 3.87521 0.996278 21.9559Z",
    fill: "url(#paint0_linear_19_955)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1514 33.616C16.0461 33.6159 15.0283 33.0144 14.495 32.0461L9.34181 22.6887C8.84027 21.778 8.8402 20.6739 9.34161 19.7632L14.4936 10.4065C15.0267 9.43832 16.0444 8.83696 17.1497 8.83703L27.2107 8.83774C28.3161 8.83782 29.3339 9.43933 29.8671 10.4076L35.0204 19.7651C35.5219 20.6758 35.522 21.7799 35.0206 22.6905L29.8686 32.0472C29.3355 33.0154 28.3178 33.6168 27.2124 33.6167L17.1514 33.616Z",
    fill: "#F8FAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.601 23.5007C13.347 23.5006 12.3267 22.4802 12.3266 21.2262C12.3265 19.9722 13.3467 18.952 14.6007 18.9521C15.8547 18.9522 16.8751 19.9725 16.8752 21.2265C16.8752 22.4806 15.855 23.5007 14.601 23.5007Z",
    fill: "#4BC875",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1815 23.5011C20.9275 23.5011 19.9071 22.4807 19.907 21.2267C19.9069 19.9726 20.9272 18.9525 22.1812 18.9526C23.4352 18.9526 24.4555 19.973 24.4556 21.227C24.4557 22.4811 23.4355 23.5012 22.1815 23.5011Z",
    fill: "#4BC875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.762 23.5018C28.508 23.5017 27.4877 22.4813 27.4876 21.2273C27.4875 19.9733 28.5077 18.9531 29.7617 18.9532C31.0157 18.9533 32.0361 19.9736 32.0362 21.2276C32.0363 22.4817 31.016 23.5018 29.762 23.5018Z",
    fill: "#4BC875",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_955",
    x1: 0.95216,
    y1: 45.5381,
    x2: 39.2696,
    y2: -6.43214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51E985"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2897,
    height: 27.2896,
    fill: "white",
    transform: "matrix(1 7.0621e-05 6.81393e-05 1 8.5354 7.58105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.67b9653be16111b1fba342f8dffe4883.svg";
export { ForwardRef as ReactComponent };